<template>
	<div class="uk-navbar-item uk-padding-small">
		<div class="uk-grid votes uk-grid-small">
			<div class="uk-width-auto uk-text-center up-vote" v-show="showUpVote">
				<div class="uk-flex uk-flex-middle uk-flex-center">
					<span
						class="material-symbols-outlined"
						:class="{ active : currentUserVote == 1, pulse : pulse }"
						@click="upVote(elementId, voteKey)">
						arrow_circle_up
					</span>
					<span v-show="!hideTotalUp && showUpVote" class="totalUpVotes uk-margin-xsmall-left">
					 {{ totalUpVotes }}
					</span>
				</div>
			</div>
			<div class="uk-width-auto uk-text-center tally-vote" v-show="showTallyVote">
				<div>{{ totalTallyVotes }}</div>
			</div>
			<div class="uk-width-auto uk-text-center down-vote" v-show="showDownVote">
				<span>
					<i
						class="material-symbols-outlined"
						:class="{ active : currentUserVote == -1, pulse : pulse }"
						@click="downVote(elementId, voteKey)"
					>arrow_circle_down</i>
				</span>
				<span v-show="!hideTotalDown && showDownVote" class="totals">
					{{ totalDownVotes }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	
	import axios from 'axios';

	export default {
			name: "upvote",
			props: {
				elementId: {
					type: Number,
					required: true,
				},
				voteKey: {
					type: String,
					default: null,
				},
				upVotes: {
					type: Number,
					default: null
				},
				downVotes: {
					type: Number,
					default: undefined,
				},
				tallyVotes: {
					type: Number,
					default: null
				},
				currentVote: {
					type: Number,
					default: null
				},
				showUpVote: {
					type: Boolean,
					default: true
				},
				showDownVote: {
					type: Boolean,
					default: true
				},
				showTallyVote: {
					type: Boolean,
					default: true
				},
				hideTotalUp: {
					type: Boolean,
					default: false
				},
				hideTotalDown: {
					type: Boolean,
					default: false
				},
			},
			data() {
				return {
					totalUpVotes: 0,
					totalDownVotes: 0,
					totalTallyVotes: 0,
					hasVoted: false,
					currentUserVote: undefined,
					pulse: false,
				};
			},
			computed: {
					downVotesTooltip() {
							return "Downvotes: " + this.totalDownVotes;
					},
					requireLogin() {
							return true;
					},
			},
			mounted() {
					var component = this;

					if (component.upVotes) {
							component.totalUpVotes = component.upVotes;
					}
					if (component.downVotes) {
							component.totalDownVotes = component.downVotes;
					}
					if (component.tallyVotes) {
							component.totalTallyVotes = component.tallyVotes;
					}
					if (component.currentVote) {
							component.currentUserVote = component.currentVote;
							component.hasVoted = true;
					}

					this.$logger(
							"app/components/upvote/mounted, elementId: " + component.elementId
					);
			},
			methods: {
					upVote(elementId, voteKey) {
							this.$logger("app/components/upvote/upVote");
							var component = this;
							var app = this.$root;
							
							if (!elementId) {
									return;
							}

							if (component.requireLogin && !app.user.loggedIn) {
									app.$helper.loginRegisterModal();
									return;
							}

							component.vote(elementId, voteKey, "upvote");
					},
					downVote(elementId, voteKey) {
							this.$logger("app/components/upvote/downVote");
							
							var app = this.$root;
							var component = this;

							if (!elementId) {
									return;
							}

							if (component.requireLogin && !this.user.loggedIn) {
									alert('register!');
									return;
							}

							component.vote(elementId, voteKey, "downvote");
					},
					vote(elementId, voteKey, type) {
							this.$logger("app/components/upvote/vote");

							var component = this;
							var app = this.$root;
							
							if (component.hasVoted && 
									((type == "downvote" && component.currentUserVote == -1) || 
									(type == "upvote" && component.currentUserVote == 1))) 
							{
									this.$logger("app/components/upvote/vote/already-voted");

									UIkit.notification({
										message: 'Je hebt al gestemd',
										status: "error",
										pos: "bottom-right",
										timeout: 3000,
									});

									return;
							}

							// Check for cookie
							var currentVotes = [];
							var vote = type == "upvote" ? 1 : -1;

							try {
									//currentVotes = JSON.parse(_helper.cookie.get("currentVotes"));
							} catch (e) {}

							if (currentVotes.length) {
									var elementExists = false;
									var voteExists = false;

									for (var i = 0; i < currentVotes.length; i++) {
											if (currentVotes[i].elementId == elementId) {
													elementExists = true;

													// Swap vote if it exists
													if (currentVotes[i].vote != vote) {
															currentVotes[i].vote = vote;
													} else {
															voteExists = true;
													}

													break;
											}
									}

									// Add new vote
									if (!elementExists && !voteExists) {
											currentVotes.push({
													elementId: elementId,
													vote: vote,
											});
									} else if (elementExists && !voteExists) {
										
											/*_helper.cookie.set({
													name: "currentVotes",
													value: JSON.stringify(currentVotes),
													expires: 365 * 10,
											});*/

											this.$logger("app/components/upvote/swap-vote/" + vote);
									} else {
											UIkit.notification({
												message: '<i class="material-symbols-outlined">report</i> Je hebt al gestemd',
												status: "error",
												pos: "bottom-right",
												timeout: 2000,
											});

											this.$logger("app/components/upvote/already-voted");
											return;
									}
							} else {
									currentVotes.push({
											elementId: elementId,
											vote: vote,
									});

									/*_helper.cookie.set({
											name: "currentVotes",
											value: JSON.stringify(currentVotes),
											expires: 365 * 10,
									});*/
							}

							// Reset pulse class
							component.pulseUp = false;
							component.pulseDown = false;

							//component.updateVoteTotals();

							// Set data
							var data = {
								id: elementId,
								key: voteKey,
							};

							// Append CSRF Token
							data[window.csrfTokenName] = window.csrfTokenValue;

							// Determine action url; should we swap votes or cast a new vote?
							var actionUrl = "/actions/upvote/vote/" + type;

							if (component.hasVoted) {
									actionUrl = "/actions/upvote/vote/swap";
							}

							// Request
							axios({
									method: "post",
									url: actionUrl,
									responseType: "json",
									data: data,
									headers: {
											"Content-Type": "application/x-www-form-urlencoded",
											Accept: "application/json",
									},
							})
							.then(function (response) {
								
									component.$logger(response);

									// Success
									var data = response.data;

									// Already voted
									if(data == "You have already voted on this element.") {

										UIkit.notification({
											message: '<i class="material-symbols-outlined">report</i> Je hebt al gestemd',
											status: "error",
											pos: "bottom-right",
											timeout: 3000,
										});

									// Voted
									} else {
										component.$logger("app/components/upvote/vote/success: " + data.vote);
										component.hasVoted = true;
										component.updateVoteTotals(data);
									}
							})
							.catch(function (error) {
								if(error) {
									console.error(error);
								}
							});
					},
					updateVoteTotals(data) {

						var component = this;

						component.$logger("app/components/upvote/vote/updateVoteTotals");
						
						component.currentUserVote = data.userVote;
						component.totalUpVotes = data.totalUpvotes;
						component.totalDownVotes = data.totalDownvotes;
						component.totalTallyvotes = data.tally;
						component.pulse = true;
					}
			},
	};
</script>

<style scoped>
	/* Add your component-specific styles here */
</style>
